import { html } from '@design.estate/dees-element';

const logResponse = (event: CustomEvent) => {
  console.log('harness-question-response', event.detail);
};

export const demoFunc = () => html`
  <style>
    .questionDemo {
      display: grid;
      gap: 16px;
      max-width: 640px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-primary);
    }
  </style>
  <div class="questionDemo" @harness-question-response=${logResponse}>
    <dees-harness-question-card
      .request=${{
        id: 'q1',
        question: 'Which database should the new service use?',
        createdAt: Date.now(),
        options: [
          { label: 'PostgreSQL', description: 'Relational, already in the stack' },
          { label: 'MongoDB', description: 'Document store, flexible schema' },
          { label: 'SQLite', description: 'Embedded, zero ops' },
        ],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q2',
        question: 'Which environments should the rollout include?',
        multiSelect: true,
        allowCustom: false,
        options: [
          { label: 'staging' },
          { label: 'production-eu' },
          { label: 'production-us' },
        ],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q3',
        question: 'Anything else I should know before migrating?',
        options: [],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      busy
      .request=${{
        id: 'q-busy',
        question: 'Waiting for the runtime — which region?',
        options: [{ label: 'eu-central' }, { label: 'us-east' }],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q4',
        question: 'Which framework for the admin UI?',
        options: [{ label: 'Lit' }, { label: 'React' }],
        response: ['Lit'],
        respondedAt: Date.now() - 60_000,
      }}
    ></dees-harness-question-card>
  </div>
`;
